import { GiWeightLiftingUp, GiWhistle, GiCalendar, GiTrophyCup } from "react-icons/gi";
import Counter from "../common/Counter";
import "./Stats.css";

const STATS = [
  { icon: GiWeightLiftingUp, value: 500, suffix: "+", label: "Active Members" },
  { icon: GiWhistle, value: 8, suffix: "+", label: "Expert Trainers" },
  { icon: GiCalendar, value: 40, suffix: "+", label: "Weekly Classes" },
  { icon: GiTrophyCup, value: 5, suffix: "+", label: "Years Building Strength" },
];

export default function Stats() {
  return (
    <section className="stats">
      <div className="container stats__grid">
        {STATS.map((stat) => {
          const Icon = stat.icon;
          return (
            <div className="stats__item" key={stat.label}>
              <Icon className="stats__icon" aria-hidden="true" />
              <p className="stats__value">
                <Counter to={stat.value} suffix={stat.suffix} />
              </p>
              <p className="stats__label">{stat.label}</p>
            </div>
          );
        })}
      </div>
      <p className="stats__note container">Figures are placeholder estimates — update with confirmed numbers.</p>
    </section>
  );
}
